import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const Graphic = ({graphic}) => { 
    let {type, fill, dimensions, transforms=[]} = graphic;
    let styleTransforms = "";
    for (let transform of transforms) {
        if (transform.type === "rotate") {
            styleTransforms += "rotate(" + transform.value + "deg) ";
        } else if (transform.type === "translate") {
            let [x,y] = transform.value;
            styleTransforms += "translate(" + x + "px, " + y + "px) ";
        } else {
            styleTransforms += transform.type + "(" + transform.value + ") ";
        }
    }
    let style = {
        transform: styleTransforms
    };
    if (fill) {
        style.fill = fill;
    }
    if (type === 'triangle') {
        let points = [0, 0, 200, 0, 100, 200];
        return (
            <polygon style={style} points={points} fill="red"/>
        );
    } else {
        return [];
    }
};

export default Graphic;
